import { lazy } from 'react';

const MerchantOffers = lazy(() => import('./MerchantOffersPage'));

const MerchantOffersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'merchant/offers/',
      element: <MerchantOffers />,
      children: [
        {
          path: ':id',
          element: <MerchantOffers />,
        },
      ],
    },
  ],
};

export default MerchantOffersConfig;
